import { ProIp } from "./ApiURL";

//post mapping :id institute_id
export const getCategoryMasterAPI = ProIp + "CategoryMaster/getCategoryMaster/mob/";

//postMapping body=branch_name, category_name

export const saveCategoryMasterAPI = ProIp + "CategoryMaster/saveCategoryMaster/mob";


//updateCategoryMaster postMapping body= id, category_name

export const updateCategoryMasterAPI = ProIp + "CategoryMaster/updateCategoryMaster/mob";

//post mapping deleteCategoryMaster body=id

export const deleteCategoryMasterAPI = ProIp + "CategoryMaster/deleteCategoryMaster/mob";